import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-daterange', 'TIME_START', 'Начальное время');
Labels.set('ui-daterange', 'TIME_END', 'Конечное время');
